import { BaseAdapter } from './base.adapter';
import type { Nudge, NudgeField, NudgeListResponseDto, NudgeResponseDto } from '@/modules/sales-agent/types';

/**
 * Sales Agent nudges from the wire. Writes need no adapter: the panel sends the payload
 * `buildNudgePayload` already trimmed and typed, as is.
 */
export class SalesNudgeAdapter extends BaseAdapter {
	/** Every field but `accountId`, which the dashboard never uses. */
	static fromApi(dto: NudgeResponseDto): Nudge {
		return {
			id: dto.id,
			buId: dto.buId,
			name: dto.name,
			prompt: dto.prompt,
			suggestions: dto.suggestions,
			status: dto.status,
			priority: dto.priority,
			rules: dto.rules,
			createdAt: dto.createdAt,
			updatedAt: dto.updatedAt
		};
	}

	static fromListApi(dto: NudgeListResponseDto | null | undefined): Nudge[] {
		return (dto?.items ?? []).map((item) => this.fromApi(item));
	}

	/** Served in display order. */
	static fieldsFromApi(dtos: NudgeField[] | null | undefined): NudgeField[] {
		return dtos ?? [];
	}
}
